module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAMAAADXqc3KAAAAWlBMVEUAAAAVqfEZrvYVqfEUqfEUqfEaqv8UqPEVqfEUqfAVqfEUqfEVqfEWqvIXqvMww/8VqfIZq/cUqPAUqfEVqfEVqfAUqfEYq/MVqvMVqvIVqfAUqfAWqPEUqPGbZQzYAAAAHXRSTlMAgBrn+bQJ18a7pqN2TSsFXx7xmZJ6b0A9PPPwXv1y42IAAACSSURBVCjPhZIJDoMgEEX9w+IuWtuqbef+1yxpCWocwk8Igccwa3GUHfpncRKtI9pK6dIw4uXdlFpVLcaN/AkR4NYPdrcF/7WEJztA2HJgZtWQBHiiTpEE/OqaBCCVB/mvvETnU63lcOuHkxN82Z8TyYJk4H3M6SLmwQKAcWkU3JsBHFu7hgSdMTF62j6XYUiNzxc27wbdtJe1zAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/comm/images/document-conversion/homeSVG/other_to_pdf_hover.png
// module id = bOzV
// module chunks = 2